// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradingStrategyConfig_container__YXv\\+s {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: var(--color-bg);
  color: var(--color-text);
  min-height: 100vh;
}

.TradingStrategyConfig_header__5pqIn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}

.TradingStrategyConfig_header__5pqIn h1 {
  font-size: 2rem;
  color: var(--color-text);
  margin: 0;
}

.TradingStrategyConfig_strategyControls__QbowO {
  display: flex;
  gap: 1rem;
}

.TradingStrategyConfig_addStrategyButton__VWurX {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--color-success);
  color: var(--color-text-strong);
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.TradingStrategyConfig_addStrategyButton__VWurX:hover {
  background-color: var(--color-success);
}

.TradingStrategyConfig_nextExecution__QwWl9 {
  background-color: var(--color-bg-muted);
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid var(--color-success);
  color: var(--color-success);
}

.TradingStrategyConfig_form__Xp7yP {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.TradingStrategyConfig_strategyGroup__-UlsP {
  background-color: var(--color-bg-panel);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.TradingStrategyConfig_strategyHeader__3yOFZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}

.TradingStrategyConfig_strategyHeader__3yOFZ h2 {
  font-size: 1.5rem;
  color: var(--color-text);
  margin: 0;
}

.TradingStrategyConfig_removeStrategyButton__fZBij {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--color-danger);
  color: var(--color-text);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.TradingStrategyConfig_removeStrategyButton__fZBij:hover {
  background-color: var(--color-danger);
}

.TradingStrategyConfig_strategyContent__1hC2c {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.TradingStrategyConfig_formRow__wOOHp {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.TradingStrategyConfig_formGroup__msyqb {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  margin-bottom: 1rem;
}

.TradingStrategyConfig_formGroup__msyqb label {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.TradingStrategyConfig_formGroup__msyqb input,
.TradingStrategyConfig_formGroup__msyqb select {
  padding: 0.75rem;
  background-color: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-text);
  font-size: 1rem;
}

.TradingStrategyConfig_formGroup__msyqb input:focus,
.TradingStrategyConfig_formGroup__msyqb select:focus {
  outline: none;
  border-color: var(--color-success);
  box-shadow: 0 0 0 2px rgba(0, 204, 0, 0.2);
}

.TradingStrategyConfig_error__TP9-Q {
  color: var(--color-danger);
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.TradingStrategyConfig_errorText__5cL1S {
  color: var(--color-danger);
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.TradingStrategyConfig_radioGroup__crBkd {
  display: flex;
  gap: 1rem;
}

.TradingStrategyConfig_radioGroup__crBkd label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.TradingStrategyConfig_radioGroup__crBkd input[type="radio"] {
  width: 1rem;
  height: 1rem;
  margin: 0;
}

.TradingStrategyConfig_seriesSection__aMJJo {
  background-color: var(--color-bg-muted);
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.TradingStrategyConfig_seriesSection__aMJJo h3 {
  font-size: 1.25rem;
  color: var(--color-text);
  margin: 0 0 1rem 0;
}

.TradingStrategyConfig_seriesGroup__gPet5 {
  background-color: var(--color-bg-alt);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.TradingStrategyConfig_seriesHeader__Xj5oP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.TradingStrategyConfig_seriesHeader__Xj5oP h4 {
  font-size: 1.1rem;
  color: var(--color-text);
  margin: 0;
}

.TradingStrategyConfig_removeSeriesButton__eM2Vc {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--color-danger);
  color: var(--color-text);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.TradingStrategyConfig_removeSeriesButton__eM2Vc:hover {
  background-color: var(--color-danger);
}

.TradingStrategyConfig_addSeriesButton__tap2k {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--color-success);
  color: var(--color-text-strong);
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 1rem;
}

.TradingStrategyConfig_addSeriesButton__tap2k:hover {
  background-color: var(--color-success);
}

.TradingStrategyConfig_formActions__sXnnW {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.TradingStrategyConfig_submitButton__7haIP {
  padding: 0.75rem 2rem;
  background-color: var(--color-success);
  color: var(--color-text-strong);
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.TradingStrategyConfig_submitButton__7haIP:hover {
  background-color: var(--color-success);
}

.TradingStrategyConfig_resetButton__-3dP0 {
  padding: 0.75rem 2rem;
  background-color: transparent;
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.TradingStrategyConfig_resetButton__-3dP0:hover {
  background-color: var(--color-bg-alt);
  border-color: rgba(255, 255, 255, 0.3);
}

.TradingStrategyConfig_previewModal__5tpbn {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.TradingStrategyConfig_previewContent__1TWT3 {
  background-color: var(--color-bg-panel);
  border-radius: 8px;
  padding: 2rem;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.TradingStrategyConfig_previewContent__1TWT3 h2 {
  font-size: 1.5rem;
  color: var(--color-text);
  margin: 0 0 1rem 0;
}

.TradingStrategyConfig_previewContent__1TWT3 pre {
  background-color: var(--color-bg-muted);
  padding: 1rem;
  border-radius: 4px;
  overflow-x: auto;
  color: var(--color-success);
}

.TradingStrategyConfig_previewContent__1TWT3 button {
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--color-success);
  color: var(--color-text-strong);
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.TradingStrategyConfig_previewContent__1TWT3 button:hover {
  background-color: var(--color-success);
}

/* Custom styles for react-select */
.select__control {
  background-color: var(--color-bg-alt) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: 4px !important;
}

.select__control:hover {
  border-color: var(--color-border) !important;
}

.select__control--is-focused {
  border-color: var(--color-success) !important;
  box-shadow: 0 0 0 1px var(--color-success) !important;
}

.select__menu {
  background-color: var(--color-bg-panel) !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.select__option {
  background-color: transparent !important;
  color: var(--color-text) !important;
}

.select__option:hover {
  background-color: rgba(0, 204, 0, 0.1) !important;
}

.select__option--is-focused {
  background-color: rgba(0, 204, 0, 0.2) !important;
}

.select__option--is-selected {
  background-color: var(--color-bg-muted) !important;
  color: var(--color-text) !important;
}

.select__multi-value {
  background-color: rgba(0, 204, 0, 0.1) !important;
  border-radius: 4px !important;
}

.select__multi-value__label {
  color: var(--color-text) !important;
}

.select__multi-value__remove:hover {
  background-color: rgba(255, 68, 68, 0.2) !important;
  color: var(--color-danger) !important;
}

.select__single-value {
  color: var(--color-text) !important;
}

.select__input {
  color: var(--color-text) !important;
}

.select__placeholder {
  color: var(--color-text-muted) !important;
}

/* Custom styles for MUI DatePicker */
.MuiInputBase-root,
.MuiInputBase-input,
.MuiOutlinedInput-input,
.MuiInputAdornment-root,
.MuiTypography-root,
.MuiFormLabel-root,
.MuiInputLabel-root,
.MuiPickersDay-root,
.MuiPickersDay-dayWithMargin,
.MuiPickersDay-today,
.MuiPickersDay-daySelected,
.MuiPickersYear-root,
.MuiPickersMonth-root,
.MuiPickersCalendarHeader-label,
.MuiPickersCalendarHeader-switchViewButton,
.MuiPickersArrowSwitcher-root,
.MuiPickersToolbarText-root,
.MuiPickersToolbarButton-root,
.MuiPickersClockNumber-root,
.MuiPickersClockPointer-root,
.MuiPickersClock-pin,
.MuiPickersClockPointer-thumb,
.MuiPickersClockPointer-root,
.MuiPickersClockPointer-thumb,
.MuiPickersClockPointer-root,
.MuiPickersClockPointer-thumb,
.MuiPickersClockPointer-root,
.MuiPickersClockPointer-thumb {
  color: var(--color-text) !important;
}
.MuiInputBase-input::placeholder {
  color: var(--color-text) !important;
  opacity: 1 !important;
}

/* Mobile styles */
@media (max-width: 768px) {
  .TradingStrategyConfig_container__YXv\\+s {
    padding: 1rem;
  }

  .TradingStrategyConfig_header__5pqIn {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .TradingStrategyConfig_formRow__wOOHp {
    grid-template-columns: 1fr;
  }

  .TradingStrategyConfig_formActions__sXnnW {
    flex-direction: column;
  }

  .TradingStrategyConfig_formActions__sXnnW button {
    width: 100%;
  }
} 

.TradingStrategyConfig_existingStrategies__pkGyi {
  margin-bottom: 2rem;
  padding: 1rem;
  background: var(--color-bg-panel);
  border-radius: 8px;
}

.TradingStrategyConfig_strategyList__fzuCI {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.TradingStrategyConfig_existingStrategyCard__pzzu7 {
  background: var(--color-bg-panel);
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid var(--color-border);
}

.TradingStrategyConfig_existingStrategyCard__pzzu7 h3 {
  margin: 0 0 1rem 0;
  color: var(--color-success);
}

.TradingStrategyConfig_strategyDetails__3Bi4y {
  font-size: 0.9rem;
}

.TradingStrategyConfig_strategyDetails__3Bi4y p {
  margin: 0.5rem 0;
}

.TradingStrategyConfig_seriesList__RE1ud {
  margin-top: 1rem;
}

.TradingStrategyConfig_seriesItem__QuUIj {
  display: flex;
  gap: 1rem;
  margin: 0.5rem 0;
  padding: 0.5rem;
  background: var(--color-bg-panel);
  border-radius: 4px;
}

.TradingStrategyConfig_submissionResult__5p27\\+ {
  margin: 2rem 0;
  padding: 1rem;
  background: var(--color-bg-panel);
  border-radius: 8px;
}

.TradingStrategyConfig_submissionResult__5p27\\+ pre {
  background: var(--color-bg-muted);
  padding: 1rem;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 0.9rem;
}

.TradingStrategyConfig_loading__-TIH0 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: var(--color-success);
}

.TradingStrategyConfig_noStrategies__Lc48X {
  text-align: center;
  padding: 2rem;
  background: var(--color-bg-panel);
  border-radius: 8px;
  margin-bottom: 2rem;
}

.TradingStrategyConfig_noStrategies__Lc48X p {
  color: var(--color-text-muted);
  font-size: 1.1rem;
}

.TradingStrategyConfig_validationErrors__78owv {
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
}

.TradingStrategyConfig_validationErrors__78owv h3 {
  color: var(--color-danger);
  margin: 0 0 1rem 0;
}

.TradingStrategyConfig_validationErrors__78owv ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.TradingStrategyConfig_validationErrors__78owv li {
  color: var(--color-danger);
  margin: 0.5rem 0;
  padding: 0.5rem;
  background: rgba(255, 0, 0, 0.05);
  border-radius: 4px;
}

.TradingStrategyConfig_validationErrors__78owv strong {
  color: var(--color-danger);
  margin-right: 0.5rem;
}

/* Strategy Table Styles */
.TradingStrategyConfig_strategyGridWrapper__xE-kw {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.TradingStrategyConfig_strategyHeaderRow__7PcRT {
  background: var(--color-bg) !important;
  color: var(--color-text) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: 4px !important;
  margin-bottom: 8px !important;
  text-align: center !important;
  font-weight: bold !important;
  padding: 12px 8px !important;
}

.TradingStrategyConfig_strategyHeaderRow__7PcRT .TradingStrategyConfig_col__jazMj {
  text-align: center !important;
  padding: 8px 4px !important;
  border-right: 1px solid var(--color-border) !important;
}

.TradingStrategyConfig_strategyHeaderRow__7PcRT .TradingStrategyConfig_col__jazMj:last-child {
  border-right: none !important;
}

.TradingStrategyConfig_strategyDataRow__Vtlz1 {
  background: var(--color-bg) !important;
  color: var(--color-text) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: 4px !important;
  margin-bottom: 4px !important;
  text-align: center !important;
  padding: 12px 8px !important;
  align-items: center !important;
}

.TradingStrategyConfig_strategyDataRow__Vtlz1 .TradingStrategyConfig_col__jazMj {
  text-align: center !important;
  padding: 8px 4px !important;
  border-right: 1px solid var(--color-border) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.TradingStrategyConfig_strategyDataRow__Vtlz1 .TradingStrategyConfig_col__jazMj:last-child {
  border-right: none !important;
}

.TradingStrategyConfig_strategyDataRow__Vtlz1:nth-child(even) {
  background: var(--color-bg-muted) !important;
}

.TradingStrategyConfig_strategyDataRow__Vtlz1.TradingStrategyConfig_totalsRow__-lOS5 {
  background: rgba(0, 204, 0, 0.2) !important;
  border: 2px solid var(--color-success) !important;
  font-weight: bold !important;
}

/* Pagination styles */
.TradingStrategyConfig_paginationControls__hSPUT {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  color: var(--color-text);
}

.TradingStrategyConfig_paginationControls__hSPUT span {
  color: var(--color-text);
  font-weight: bold;
  margin: 0 16px;
} `, "",{"version":3,"sources":["webpack://./src/components/TradingStrategy/TradingStrategyConfig.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,qCAAqC;AACrC;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gDAAgD;EAChD,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gDAAgD;EAChD,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sDAAsD;EACtD,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.header h1 {\n  font-size: 2rem;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.strategyControls {\n  display: flex;\n  gap: 1rem;\n}\n\n.addStrategyButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--color-success);\n  color: var(--color-text-strong);\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.addStrategyButton:hover {\n  background-color: var(--color-success);\n}\n\n.nextExecution {\n  background-color: var(--color-bg-muted);\n  padding: 1rem;\n  border-radius: 4px;\n  border: 1px solid var(--color-success);\n  color: var(--color-success);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.strategyGroup {\n  background-color: var(--color-bg-panel);\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.strategyHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.strategyHeader h2 {\n  font-size: 1.5rem;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.removeStrategyButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: var(--color-danger);\n  color: var(--color-text);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.removeStrategyButton:hover {\n  background-color: var(--color-danger);\n}\n\n.strategyContent {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.formRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.formGroup label {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.formGroup input,\n.formGroup select {\n  padding: 0.75rem;\n  background-color: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  color: var(--color-text);\n  font-size: 1rem;\n}\n\n.formGroup input:focus,\n.formGroup select:focus {\n  outline: none;\n  border-color: var(--color-success);\n  box-shadow: 0 0 0 2px rgba(0, 204, 0, 0.2);\n}\n\n.error {\n  color: var(--color-danger);\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n}\n\n.errorText {\n  color: var(--color-danger);\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n.radioGroup {\n  display: flex;\n  gap: 1rem;\n}\n\n.radioGroup label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.radioGroup input[type=\"radio\"] {\n  width: 1rem;\n  height: 1rem;\n  margin: 0;\n}\n\n.seriesSection {\n  background-color: var(--color-bg-muted);\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n}\n\n.seriesSection h3 {\n  font-size: 1.25rem;\n  color: var(--color-text);\n  margin: 0 0 1rem 0;\n}\n\n.seriesGroup {\n  background-color: var(--color-bg-alt);\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.seriesHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.seriesHeader h4 {\n  font-size: 1.1rem;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.removeSeriesButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: var(--color-danger);\n  color: var(--color-text);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.removeSeriesButton:hover {\n  background-color: var(--color-danger);\n}\n\n.addSeriesButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--color-success);\n  color: var(--color-text-strong);\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 1rem;\n}\n\n.addSeriesButton:hover {\n  background-color: var(--color-success);\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.submitButton {\n  padding: 0.75rem 2rem;\n  background-color: var(--color-success);\n  color: var(--color-text-strong);\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.submitButton:hover {\n  background-color: var(--color-success);\n}\n\n.resetButton {\n  padding: 0.75rem 2rem;\n  background-color: transparent;\n  color: var(--color-text);\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.resetButton:hover {\n  background-color: var(--color-bg-alt);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.previewModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.previewContent {\n  background-color: var(--color-bg-panel);\n  border-radius: 8px;\n  padding: 2rem;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.previewContent h2 {\n  font-size: 1.5rem;\n  color: var(--color-text);\n  margin: 0 0 1rem 0;\n}\n\n.previewContent pre {\n  background-color: var(--color-bg-muted);\n  padding: 1rem;\n  border-radius: 4px;\n  overflow-x: auto;\n  color: var(--color-success);\n}\n\n.previewContent button {\n  margin-top: 1rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--color-success);\n  color: var(--color-text-strong);\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.previewContent button:hover {\n  background-color: var(--color-success);\n}\n\n/* Custom styles for react-select */\n:global(.select__control) {\n  background-color: var(--color-bg-alt) !important;\n  border: 1px solid var(--color-border) !important;\n  border-radius: 4px !important;\n}\n\n:global(.select__control:hover) {\n  border-color: var(--color-border) !important;\n}\n\n:global(.select__control--is-focused) {\n  border-color: var(--color-success) !important;\n  box-shadow: 0 0 0 1px var(--color-success) !important;\n}\n\n:global(.select__menu) {\n  background-color: var(--color-bg-panel) !important;\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\n}\n\n:global(.select__option) {\n  background-color: transparent !important;\n  color: var(--color-text) !important;\n}\n\n:global(.select__option:hover) {\n  background-color: rgba(0, 204, 0, 0.1) !important;\n}\n\n:global(.select__option--is-focused) {\n  background-color: rgba(0, 204, 0, 0.2) !important;\n}\n\n:global(.select__option--is-selected) {\n  background-color: var(--color-bg-muted) !important;\n  color: var(--color-text) !important;\n}\n\n:global(.select__multi-value) {\n  background-color: rgba(0, 204, 0, 0.1) !important;\n  border-radius: 4px !important;\n}\n\n:global(.select__multi-value__label) {\n  color: var(--color-text) !important;\n}\n\n:global(.select__multi-value__remove:hover) {\n  background-color: rgba(255, 68, 68, 0.2) !important;\n  color: var(--color-danger) !important;\n}\n\n:global(.select__single-value) {\n  color: var(--color-text) !important;\n}\n\n:global(.select__input) {\n  color: var(--color-text) !important;\n}\n\n:global(.select__placeholder) {\n  color: var(--color-text-muted) !important;\n}\n\n/* Custom styles for MUI DatePicker */\n:global(.MuiInputBase-root),\n:global(.MuiInputBase-input),\n:global(.MuiOutlinedInput-input),\n:global(.MuiInputAdornment-root),\n:global(.MuiTypography-root),\n:global(.MuiFormLabel-root),\n:global(.MuiInputLabel-root),\n:global(.MuiPickersDay-root),\n:global(.MuiPickersDay-dayWithMargin),\n:global(.MuiPickersDay-today),\n:global(.MuiPickersDay-daySelected),\n:global(.MuiPickersYear-root),\n:global(.MuiPickersMonth-root),\n:global(.MuiPickersCalendarHeader-label),\n:global(.MuiPickersCalendarHeader-switchViewButton),\n:global(.MuiPickersArrowSwitcher-root),\n:global(.MuiPickersToolbarText-root),\n:global(.MuiPickersToolbarButton-root),\n:global(.MuiPickersClockNumber-root),\n:global(.MuiPickersClockPointer-root),\n:global(.MuiPickersClock-pin),\n:global(.MuiPickersClockPointer-thumb),\n:global(.MuiPickersClockPointer-root),\n:global(.MuiPickersClockPointer-thumb),\n:global(.MuiPickersClockPointer-root),\n:global(.MuiPickersClockPointer-thumb),\n:global(.MuiPickersClockPointer-root),\n:global(.MuiPickersClockPointer-thumb) {\n  color: var(--color-text) !important;\n}\n:global(.MuiInputBase-input::placeholder) {\n  color: var(--color-text) !important;\n  opacity: 1 !important;\n}\n\n/* Mobile styles */\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .formRow {\n    grid-template-columns: 1fr;\n  }\n\n  .formActions {\n    flex-direction: column;\n  }\n\n  .formActions button {\n    width: 100%;\n  }\n} \n\n.existingStrategies {\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background: var(--color-bg-panel);\n  border-radius: 8px;\n}\n\n.strategyList {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.existingStrategyCard {\n  background: var(--color-bg-panel);\n  border-radius: 8px;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n}\n\n.existingStrategyCard h3 {\n  margin: 0 0 1rem 0;\n  color: var(--color-success);\n}\n\n.strategyDetails {\n  font-size: 0.9rem;\n}\n\n.strategyDetails p {\n  margin: 0.5rem 0;\n}\n\n.seriesList {\n  margin-top: 1rem;\n}\n\n.seriesItem {\n  display: flex;\n  gap: 1rem;\n  margin: 0.5rem 0;\n  padding: 0.5rem;\n  background: var(--color-bg-panel);\n  border-radius: 4px;\n}\n\n.submissionResult {\n  margin: 2rem 0;\n  padding: 1rem;\n  background: var(--color-bg-panel);\n  border-radius: 8px;\n}\n\n.submissionResult pre {\n  background: var(--color-bg-muted);\n  padding: 1rem;\n  border-radius: 4px;\n  overflow-x: auto;\n  font-size: 0.9rem;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  color: var(--color-success);\n}\n\n.noStrategies {\n  text-align: center;\n  padding: 2rem;\n  background: var(--color-bg-panel);\n  border-radius: 8px;\n  margin-bottom: 2rem;\n}\n\n.noStrategies p {\n  color: var(--color-text-muted);\n  font-size: 1.1rem;\n}\n\n.validationErrors {\n  background: rgba(255, 0, 0, 0.1);\n  border: 1px solid rgba(255, 0, 0, 0.3);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 2rem;\n}\n\n.validationErrors h3 {\n  color: var(--color-danger);\n  margin: 0 0 1rem 0;\n}\n\n.validationErrors ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.validationErrors li {\n  color: var(--color-danger);\n  margin: 0.5rem 0;\n  padding: 0.5rem;\n  background: rgba(255, 0, 0, 0.05);\n  border-radius: 4px;\n}\n\n.validationErrors strong {\n  color: var(--color-danger);\n  margin-right: 0.5rem;\n}\n\n/* Strategy Table Styles */\n.strategyGridWrapper {\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.strategyHeaderRow {\n  background: var(--color-bg) !important;\n  color: var(--color-text) !important;\n  border: 1px solid var(--color-border) !important;\n  border-radius: 4px !important;\n  margin-bottom: 8px !important;\n  text-align: center !important;\n  font-weight: bold !important;\n  padding: 12px 8px !important;\n}\n\n.strategyHeaderRow .col {\n  text-align: center !important;\n  padding: 8px 4px !important;\n  border-right: 1px solid var(--color-border) !important;\n}\n\n.strategyHeaderRow .col:last-child {\n  border-right: none !important;\n}\n\n.strategyDataRow {\n  background: var(--color-bg) !important;\n  color: var(--color-text) !important;\n  border: 1px solid var(--color-border) !important;\n  border-radius: 4px !important;\n  margin-bottom: 4px !important;\n  text-align: center !important;\n  padding: 12px 8px !important;\n  align-items: center !important;\n}\n\n.strategyDataRow .col {\n  text-align: center !important;\n  padding: 8px 4px !important;\n  border-right: 1px solid var(--color-border) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.strategyDataRow .col:last-child {\n  border-right: none !important;\n}\n\n.strategyDataRow:nth-child(even) {\n  background: var(--color-bg-muted) !important;\n}\n\n.strategyDataRow.totalsRow {\n  background: rgba(0, 204, 0, 0.2) !important;\n  border: 2px solid var(--color-success) !important;\n  font-weight: bold !important;\n}\n\n/* Pagination styles */\n.paginationControls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  color: var(--color-text);\n}\n\n.paginationControls span {\n  color: var(--color-text);\n  font-weight: bold;\n  margin: 0 16px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TradingStrategyConfig_container__YXv+s`,
	"header": `TradingStrategyConfig_header__5pqIn`,
	"strategyControls": `TradingStrategyConfig_strategyControls__QbowO`,
	"addStrategyButton": `TradingStrategyConfig_addStrategyButton__VWurX`,
	"nextExecution": `TradingStrategyConfig_nextExecution__QwWl9`,
	"form": `TradingStrategyConfig_form__Xp7yP`,
	"strategyGroup": `TradingStrategyConfig_strategyGroup__-UlsP`,
	"strategyHeader": `TradingStrategyConfig_strategyHeader__3yOFZ`,
	"removeStrategyButton": `TradingStrategyConfig_removeStrategyButton__fZBij`,
	"strategyContent": `TradingStrategyConfig_strategyContent__1hC2c`,
	"formRow": `TradingStrategyConfig_formRow__wOOHp`,
	"formGroup": `TradingStrategyConfig_formGroup__msyqb`,
	"error": `TradingStrategyConfig_error__TP9-Q`,
	"errorText": `TradingStrategyConfig_errorText__5cL1S`,
	"radioGroup": `TradingStrategyConfig_radioGroup__crBkd`,
	"seriesSection": `TradingStrategyConfig_seriesSection__aMJJo`,
	"seriesGroup": `TradingStrategyConfig_seriesGroup__gPet5`,
	"seriesHeader": `TradingStrategyConfig_seriesHeader__Xj5oP`,
	"removeSeriesButton": `TradingStrategyConfig_removeSeriesButton__eM2Vc`,
	"addSeriesButton": `TradingStrategyConfig_addSeriesButton__tap2k`,
	"formActions": `TradingStrategyConfig_formActions__sXnnW`,
	"submitButton": `TradingStrategyConfig_submitButton__7haIP`,
	"resetButton": `TradingStrategyConfig_resetButton__-3dP0`,
	"previewModal": `TradingStrategyConfig_previewModal__5tpbn`,
	"previewContent": `TradingStrategyConfig_previewContent__1TWT3`,
	"existingStrategies": `TradingStrategyConfig_existingStrategies__pkGyi`,
	"strategyList": `TradingStrategyConfig_strategyList__fzuCI`,
	"existingStrategyCard": `TradingStrategyConfig_existingStrategyCard__pzzu7`,
	"strategyDetails": `TradingStrategyConfig_strategyDetails__3Bi4y`,
	"seriesList": `TradingStrategyConfig_seriesList__RE1ud`,
	"seriesItem": `TradingStrategyConfig_seriesItem__QuUIj`,
	"submissionResult": `TradingStrategyConfig_submissionResult__5p27+`,
	"loading": `TradingStrategyConfig_loading__-TIH0`,
	"noStrategies": `TradingStrategyConfig_noStrategies__Lc48X`,
	"validationErrors": `TradingStrategyConfig_validationErrors__78owv`,
	"strategyGridWrapper": `TradingStrategyConfig_strategyGridWrapper__xE-kw`,
	"strategyHeaderRow": `TradingStrategyConfig_strategyHeaderRow__7PcRT`,
	"col": `TradingStrategyConfig_col__jazMj`,
	"strategyDataRow": `TradingStrategyConfig_strategyDataRow__Vtlz1`,
	"totalsRow": `TradingStrategyConfig_totalsRow__-lOS5`,
	"paginationControls": `TradingStrategyConfig_paginationControls__hSPUT`
};
export default ___CSS_LOADER_EXPORT___;
